(function ($) {
  DGS.Resizer.getInstance().register(function () {
    // hide all forms in css and load then with JS when all info is ready

    // decide if form will fit inside intro banner or should it stack
    $('.component.intro-banner + .component.form.form-on-top').each(function () {
      $(this).removeClass('form-overflow');
      var bannerHight = $(this).prev('.component.intro-banner').outerHeight();
      var availableSpace = bannerHight - $('#header').outerHeight();
      var form = $(this).find('.scfForm');
      if (availableSpace <= form.outerHeight()) {
        $(this).addClass('form-overflow');
      } else {
        var topMargin = 0 - form.outerHeight() - 20;
        form.css({
          top: topMargin
        });
      }
    });

    // for wide form place the button inside .scfSectionContent container
    $('.component.form.align-button').each(function () {
      $button = $(this).find('.scfSubmitButtonBorder');
      $content = $(this).find('.scfSectionContent');
      $content.append($button);
    });
    $('.component.form.telNumLengthValidate .scfTelephoneTextBox').attr('minlength', '10').attr('maxlength', '10');
    $('.component.form.telNumLengthValidate .scfTelephoneTextBox').on('invalid', function (e) {
      e.preventDefault();
      $(this).nextAll('.scfValidator').first().show();
    });
    $('.component.form.telNumLengthValidate .scfTelephoneTextBox').on('valid', function (e) {
      $(this).nextAll('.scfValidator').first().hide();
    });
    setTimeout(function () {
      $('.component.form').each(function () {
        $(this).css('opacity', 1);
      });
    }, 1000);
  });
  DGS.OnLoad.getInstance().register(function () {
    // set placeholders from labels
    $('.component.form .scfSingleLineTextBox, .component.form .scfEmailTextBox, .component.form .scfTelephoneTextBox, .component.form .scfMultipleLineTextBox').each(function () {
      var $label = $(this).parent().prev('label').text();
      $(this).attr('placeholder', $label);
    });
  });
})(jQuery);